import React, { Component } from 'react'
import { Button, Card, Checkbox, Radio, Steps, Table } from 'antd'
import { api, app } from "../app"
import utils from "../utils"

const CheckboxGroup = Checkbox.Group
const RadioGroup = Radio.Group
const Step = Steps.Step

class PlayerSelector extends Component {
    constructor(props) {
        super(props)
        this.state = {
            step: 0,
            step_key: null,
            steps: [],
            start_step: 1,
            provinceList: [],
            p_checks: [],
            p_indeterminate: false,
            p_check_all: false,
            teamList: {},
            t_checks: [],
            t_all_checks: [],
            t_indeterminate: false,
            t_check_all: false,
            f_indeterminate: false,
            f_check_all: false,
            f_checks: [],
            filter_options: [],
            filter_types: [
                { label: '身份', value: '2', options: [] },
                { label: '职位', value: '1', options: [] },
            ],
            filter_type: '2',
            p_loading: false,
            p_total: 0,
            p_page: 1,
            playerList: [],
            removePlayerList: [],
            grade: props.grade
        }
    }

    async componentDidMount() {
        this._isMounted = true
        this.props.onRef(this)
        await this.handleFilterData()
        await this.handleStep()
    }

    async componentWillReceiveProps(nextProps) {
        if (this.props.grade !== nextProps.grade) {
            await this.setData({
                grade: nextProps.grade,
                provinceList: [],
                p_checks: [],
                p_indeterminate: false,
                p_check_all: false,
                teamList: {},
                t_checks: [],
                t_all_checks: [],
                t_indeterminate: false,
                t_check_all: false,
                f_indeterminate: false,
                f_check_all: false,
                f_checks: [],
                p_loading: false,
                p_total: 0,
                p_page: 1,
                playerList: [],
                removePlayerList: [],
            })
            await this.handleStep()
        }
    }

    /**
     * 获取值
     * @returns {{team, user: string}}
     */
    getValue = () => {
        const { p_checks, f_checks, t_checks, filter_type, playerList, removePlayerList } = this.state
        if (!playerList.length) {
            app.alert('请选择发布对象！', 'warn')
            throw false
        }
        const value = { team: t_checks.join(','), user: '', state_type: filter_type, state: f_checks.join(','), province: p_checks.join(',') }
        if (removePlayerList.length > 0) {
            value.type = 3
            value.user = removePlayerList.join(',')
        } else {
            value.type = 1
        }
        return value
    }

    /**
     * 省份数据
     */
    provinceTeamData = async (type, province) => {
        const params = {
            type,
            level: this.state.grade,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        if (type === 2) params.province = province
        let url = ''
        if (this.props.type === 'message') {
            url = api.MProvinceTeamAll
        } else if (this.props.type === 'train') {
            url = api.tProvinceTeamAll
        }
        let { flag, data, msg } = await app.post(url, params)
        if (flag === 1) {
            if (type === 1) {
                return data.map(d => d.area_name)
            } else {
                let t_all_checks = []
                for (let k in data) {
                    for (let i = 0; i < data[k].length; i++) {
                        t_all_checks.push(data[k][i].teamno)
                    }
                }
                return { teamList: data, t_all_checks }
            }
        } else {
            app.alert(msg, "error")
            if (type === 1) {
                return []
            } else {
                return { teamList: {}, t_all_checks: [] }
            }
        }
    }

    /**
     * 队员数据
     */
    playerData = async (page = 1, flush) => {
        const state = { p_page: page, p_loading: true }
        if (flush) {
            state.playerList = []
            state.removePlayerList = []
        }
        await this.setData(state)
        const { f_checks, t_checks, filter_type, removePlayerList } = this.state, params = {
            page,
            type: filter_type,
            id: f_checks.join(','),
            teamno: t_checks.join(','),
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let url = ''
        if (this.props.type === 'message') {
            url = api.UserAll
        } else if (this.props.type === 'train') {
            url = api.tUserAll
        }
        let { flag, data, msg, total } = await app.post(url, params)
        if (flag === 1) {
            if (page === 1 && !data.length) {
                app.alert('筛选条件下无对应人员，请重新选择！', 'warn', '35%', 2.5)
                await app.sleep()
                await this.handlePrev()
                return
            }
            data = data.filter(p => removePlayerList.indexOf(p.indexno) === -1)
            total -= removePlayerList.length
        } else {
            data = []
            app.alert(msg, "error")
        }
        if (page === this.state.p_page) {
            await this.setData({ p_loading: false, p_total: parseInt(total || 0), playerList: utils.addArrayKey(data) })
        }
    }

    /**
     * 筛选数据
     * @returns {Promise<void>}
     */
    handleFilterData = async () => {
        const params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let url = ''
        if (this.props.type === 'message') {
            url = api.PositionIdentityList
        } else if (this.props.type === 'train') {
            url = api.tPositionIdentityList
        }
        let { flag, data, msg } = await app.post(api.PositionIdentityList, params)
        if (flag === 1) {
            let { filter_types } = this.state
            filter_types[0].options = data.identity.map(p => ({ label: p.name, value: p.id }))
            filter_types[1].options = data.position.map(p => ({ label: p.name, value: p.id }))
            await this.setData({ filter_types, filter_options: filter_types[0].options })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 处理级数
     */
    handleStep = async () => {
        const steps = [
            { title: '选择省份', step_key: 1 },
            { title: '选择队伍', step_key: 2 },
            { title: '筛选人员', step_key: 3 },
            { title: '筛选结果', step_key: 4 }
        ]
        let provinceList = await this.provinceTeamData(1)
        await this.setData({ steps, provinceList, step: 0, step_key: steps[0].step_key })
    }

    /**
     * 下一步
     */
    handleNext = async () => {
        const step = this.state.step + 1
        const step_key = this.state.steps[step].step_key
        const state = { step, step_key }
        const { t_checks, filter_types } = this.state
        switch (step_key) {
            case 2:
                let { p_checks } = this.state
                if (!p_checks.length) {
                    app.alert('请选择省份！', 'warn')
                    return
                }
                let { teamList, t_all_checks } = await this.provinceTeamData(2, this.state.p_checks.join(','))
                state.teamList = teamList
                state.t_all_checks = t_all_checks
                state.t_checks = []
                state.t_indeterminate = false
                state.t_check_all = false
                await this.setData(state)
                break
            case 3:
                if (!t_checks.length) {
                    app.alert('请选择队伍！', 'warn')
                    return
                }
                state.f_check_all = false
                state.f_indeterminate = false
                state.f_checks = []
                state.filter_type = '2'
                state.filter_options = filter_types[0].options
                await this.setData(state)
                break
            case 4:
                let { f_checks } = this.state
                if (!f_checks.length) {
                    app.alert('请选择筛选条件！', 'warn')
                    return
                }
                await this.setData(state)
                await this.playerData(1, true)
                break
        }
    }

    /**
     * 上一步
     */
    handlePrev = () => {
        const step = this.state.step - 1
        this.setData({ step, step_key: this.state.steps[step].step_key })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 筛选条件变更
     * @param e
     */
    handleFilterChange = (e) => {
        let { value } = e.target, { filter_types } = this.state, index = filter_types.findIndex(f => f.value === value)
        if (index === -1) {
            return
        }
        this.setData({
            filter_type: value,
            f_checks: [],
            f_indeterminate: false,
            f_check_all: false,
            filter_options: filter_types[index].options
        })
    }

    /**
     * 移除队员
     * @param indexno
     */
    handleRemovePlayer = (indexno) => {
        if (!indexno) return
        const playerList = [...this.state.playerList]
        this.state.removePlayerList.push(indexno)
        this.setData({ playerList: playerList.filter(p => p.indexno !== indexno), p_total: this.state.p_total - 1 })
    }

    render() {
        let {
            step, step_key, steps, provinceList, p_indeterminate, p_check_all, p_checks, t_indeterminate, t_check_all, t_checks, t_all_checks, teamList,
            f_checks, filter_types, filter_type, f_indeterminate, f_check_all, filter_options, p_loading, playerList, p_page, p_total
        } = this.state,
            columns = [
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%'
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '10%'
                },
                {
                    title: '所属队伍',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '30%'
                },
                {
                    title: '队内职位',
                    dataIndex: 'teampositionname',
                    key: 'teampositionname',
                    width: '15%'
                },
                {
                    title: '队员身份',
                    dataIndex: 'volunteer_state',
                    key: 'volunteer_state',
                    width: '15%',
                    render: (vs) => {
                        switch (vs) {
                            case '1':
                                return '队员'
                            case '2':
                                return '预备队员'
                            case '3':
                                return '认证志愿者'
                            case '4':
                                return '离队'
                            case '5':
                                return '清退'
                            default:
                                return '未设置'
                        }
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'indexno',
                    key: 'indexno',
                    width: '15%',
                    render: (indexno) => {
                        return (
                            <Button size="small" type="primary"
                                onClick={() => this.handleRemovePlayer(indexno)}>移除</Button>
                        )
                    }
                },
            ],
            content = null
        switch (step_key) {
            case 1:
                content = (
                    <div>
                        <div style={{ borderBottom: '1px solid #E9E9E9', paddingBottom: 5, marginBottom: 5 }}>
                            <Checkbox
                                indeterminate={p_indeterminate}
                                checked={p_check_all}
                                onChange={(e) => this.setData({
                                    p_checks: e.target.checked ? provinceList : [],
                                    p_indeterminate: false,
                                    p_check_all: e.target.checked
                                })}
                                style={{ fontWeight: 'bold' }}
                            >全部</Checkbox>
                        </div>
                        <CheckboxGroup options={provinceList} value={p_checks}
                            onChange={checkedList => this.setData({
                                p_checks: checkedList,
                                p_indeterminate: !!checkedList.length && (checkedList.length < provinceList.length),
                                p_check_all: checkedList.length === provinceList.length,
                            })} />
                    </div>
                )
                break
            case 2:
                content = (
                    <div>
                        <div style={{ borderBottom: '1px solid #E9E9E9', paddingBottom: 5 }}>
                            <Checkbox
                                indeterminate={t_indeterminate}
                                checked={t_check_all}
                                onChange={(e) => this.setData({
                                    t_checks: e.target.checked ? t_all_checks : [],
                                    t_indeterminate: false,
                                    t_check_all: e.target.checked
                                })}
                                style={{ fontWeight: 'bold' }}
                            >所有队伍</Checkbox>
                        </div>
                        <CheckboxGroup value={t_checks} onChange={checkedList => this.setData({
                            t_checks: checkedList,
                            t_indeterminate: !!checkedList.length && (checkedList.length < t_all_checks.length),
                            t_check_all: checkedList.length === t_all_checks.length,
                        })}>
                            {
                                Object.keys(teamList).map((p, i) => {
                                    return (
                                        <div key={i} style={{ paddingLeft: 20, marginTop: 10 }}>
                                            <div
                                                style={{ color: '#888', fontWeight: 'bold', marginBottom: 5 }}>{p}</div>
                                            <div style={{ paddingLeft: 20 }}>
                                                {
                                                    !teamList[p] || !teamList[p].length ? (
                                                        <div style={{ color: '#999' }}>暂无队伍</div>) :
                                                        teamList[p].map(t => <Checkbox key={t.team_id}
                                                            value={t.teamno}>{t.teamname}</Checkbox>)
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </CheckboxGroup>
                    </div>
                )
                break
            case 3:
                let filter_text = filter_type === '2' ? '身份' : '职位'
                content = (
                    <div>
                        <div>
                            <span style={{ paddingRight: 10 }}>筛选类型 : </span>
                            <RadioGroup options={filter_types}
                                onChange={this.handleFilterChange}
                                value={filter_type} />
                        </div>
                        <div style={{ padding: '10px 20px' }}>
                            <div style={{
                                borderBottom: '1px solid #E9E9E9',
                                paddingBottom: 5,
                                marginBottom: 5
                            }}>
                                <Checkbox
                                    indeterminate={f_indeterminate}
                                    checked={f_check_all}
                                    onChange={(e) => this.setData({
                                        f_checks: e.target.checked ? filter_options.map(f => f.value) : [],
                                        f_indeterminate: false,
                                        f_check_all: e.target.checked
                                    })}
                                    style={{ fontWeight: 'bold' }}
                                >全部{filter_text}</Checkbox>
                            </div>
                            <CheckboxGroup options={filter_options}
                                onChange={(checkedList) => this.setData({
                                    f_checks: checkedList,
                                    f_indeterminate: !!checkedList.length && (checkedList.length < filter_options.length),
                                    f_check_all: checkedList.length === filter_options.length,
                                })} value={f_checks} />
                        </div>
                    </div>
                )
                break
            case 4:
                content = (
                    <Table
                        columns={columns}
                        locale={app.tbLocale(p_loading)}
                        loading={p_loading}
                        dataSource={playerList}
                        scroll={{ y: 600 }}
                        style={{ width: 800 }}
                        size="small"
                        className="table-odd-even-row"
                        pagination={{
                            total: p_total,
                            current: p_page,
                            showTotal: (t) => `总数量: ${t}条 `,
                            pageSize: 100,
                            onChange: (p) => this.playerData(p)
                        }}
                    />
                )
                break
        }
        return (
            <Card bodyStyle={{ padding: 20 }} title={
                <div>
                    <span>发布对象</span>
                    <span style={{ color: "#faad14", fontSize: 12, marginBottom: 10 }}>
                        （由于数据量较大，可能导致加载速度较慢，请您耐心等候~）
                    </span>
                </div>
            } extra={
                <span style={{ marginLeft: 20, fontSize: 12 }}>总选 <b>{p_total}</b> 人</span>
            }>
                <Steps size="small" current={step}>
                    {
                        steps.map((st, i) => <Step key={i} title={st.title} />)
                    }
                </Steps>
                <div className="steps-content" style={{ padding: '20px 0' }}>{content}</div>
                <div className="steps-action">
                    {
                        step > 0 &&
                        (<Button style={{ marginRight: 8 }} onClick={this.handlePrev}>
                            上一步
                        </Button>)
                    }
                    {
                        step < steps.length - 1
                        && <Button type="primary" onClick={this.handleNext}>下一步</Button>
                    }
                </div>
            </Card>
        )
    }
}

export default PlayerSelector



// WEBPACK FOOTER //
// ./src/components/PlayerSelector.jsx